<div class="input-group">
  <app-loan-input label="Full Name" [control]="$any(applicantFormGroup).get('fullName')" />
</div>

<div class="input-group">
  <app-loan-datepicker label="Date of Birth" [control]="$any(applicantFormGroup).get('dob')" />
  <app-loan-input label="Social Security Number / TIN" [control]="$any(applicantFormGroup).get('social')" />
</div>

<div class="input-group">
  <app-loan-input label="Email" [control]="$any(applicantFormGroup).get('email')" [readonly]="readonlyEmail" [tooltipText]="emailTooltipText" />
  <app-loan-input label="Phone" [control]="$any(applicantFormGroup).get('phone')" />
</div>

<app-loan-input label="Home Address" [control]="$any(applicantFormGroup).get('address')" />

<div class="input-group">
  <app-loan-input label="City" [control]="$any(applicantFormGroup).get('city')" />
  <app-loan-select label="State" [control]="$any(applicantFormGroup).get('state')" [options]="states" />
  <app-loan-input label="ZIP Code" [control]="$any(applicantFormGroup).get('zip')" />
</div>

<app-sub-header text="Bankruptcy or Judgement in the past 7 years?" headerSize="h5" />
<app-loan-radio [values]="['Yes', 'No']" [control]="$any(applicantFormGroup).get('bankruptcy')" />

@if (showBankruptcy) {
  <div class="input-group">
    <app-loan-textarea label="Please Explain" [control]="$any(applicantFormGroup).get('explain')" />
    <app-loan-datepicker label="Date" [control]="$any(applicantFormGroup).get('dateBankruptcy')" />
  </div>
}

<app-divider />

<app-sub-header text="Employer Information" />
<div class="input-group">
  <app-loan-input label="Employer" [control]="$any(applicantFormGroup).get('employer')" />
  <app-loan-input label="Length of Time Employed" [control]="$any(applicantFormGroup).get('lengthEmployed')" />
</div>

<app-loan-checkbox
  class="employer-same-as-home"
  text="Same as above"
  questionText="Fills employer address and employer phone from your home address and phone above."
  [groupName]="employerSameAsHomeGroupName"
  [control]="employerSameAsHomeControl"
/>

<app-loan-input label="Employer Address" [control]="$any(applicantFormGroup).get('employerAddress')" />

<div class="input-group">
  <app-loan-input label="City" [control]="$any(applicantFormGroup).get('employerCity')" />
  <app-loan-select label="State" [control]="$any(applicantFormGroup).get('employerState')" [options]="states" />
  <app-loan-input label="ZIP Code" [control]="$any(applicantFormGroup).get('employerZip')" />
</div>

<div class="emp-phone">
  <app-loan-input label="Employer Phone" [control]="$any(applicantFormGroup).get('employerPhone')" />
</div>
